import { round } from 'lodash-es';

import { FCStatus, FoodComponent } from '../types';
import { getActualCookedWeightStation, hasActualCookedWeightEntered } from './foodComponentHelper';

export default function getPercComponentsCompleted(station: string, foodComponents: FoodComponent[]) {
  const { total, completed } = foodComponents.reduce(
    (acc, foodComponent) => {
      const cookingStation = foodComponent.cookingStations?.find((cs) => cs?.name === station);
      if (cookingStation) {
        acc.total += 1;
        const requiresActualCookedWeight = getActualCookedWeightStation(foodComponent) === station;
        if (
          cookingStation.status === FCStatus.completed &&
          (!requiresActualCookedWeight || hasActualCookedWeightEntered(foodComponent))
        ) {
          acc.completed += 1;
        }
      }
      return acc;
    },
    { total: 0, completed: 0 }
  );

  return round((completed / (total || 1)) * 100);
}
